import React, { useEffect, useState, useCallback } from 'react';
import './TTT.css';

const TicTacToe = () => { 
    const defaultBoard = [
        ' ', ' ', ' ',
        ' ', ' ', ' ',
        ' ', ' ', ' '
    ];
    
    const [selections, setSelections] = useState(defaultBoard);
    const [turn, setTurn] = useState(1);
    const [winner, setWinner] = useState(null);
    
    const findWinner = useCallback(() => {
        if (selections[0] === 'X' && selections[1] === 'X' && selections[2] === 'X') return 1;
        else if (selections[0] === 'O' && selections[1] === 'O' && selections[2] === 'O') return 2;
        
        if (selections[3] === 'X' && selections[4] === 'X' && selections[5] === 'X') return 1;
        else if (selections[3] === 'O' && selections[4] === 'O' && selections[5] === 'O') return 2;
        
        if (selections[6] === 'X' && selections[7] === 'X' && selections[8] === 'X') return 1;
        else if (selections[6] === 'O' && selections[7] === 'O' && selections[8] === 'O') return 2;
    
        
        if (selections[0] === 'X' && selections[3] === 'X' && selections[6] === 'X') return 1;
        else if (selections[0] === 'O' && selections[3] === 'O' && selections[6] === 'O') return 2;
        
        if (selections[1] === 'X' && selections[4] === 'X' && selections[7] === 'X') return 1;
        else if (selections[1] === 'O' && selections[4] === 'O' && selections[7] === 'O') return 2;
        
        if (selections[2] === 'X' && selections[5] === 'X' && selections[8] === 'X') return 1;
        else if (selections[2] === 'O' && selections[5] === 'O' && selections[8] === 'O') return 2;
    
        if (selections[0] === 'X' && selections[4] === 'X' && selections[8] === 'X') return 1;
        else if (selections[0] === 'O' && selections[4] === 'O' && selections[8] === 'O') return 2;
        
        if (selections[2] === 'X' && selections[4] === 'X' && selections[6] === 'X') return 1;
        else if (selections[2] === 'O' && selections[4] === 'O' && selections[6] === 'O') return 2;
        
        let endGame = true;
        for (let val of selections) {
            if (val === ' ') {
                endGame = false;
                break;
            };
        };

        if (endGame) return 3;
        return null;
    }, [selections]);

    useEffect(() => {
        const checkWinner = findWinner();
        setWinner(checkWinner);
    }, [selections, findWinner]);

    const updateSelections = (index) => {
        if (winner) return;
        
        const item = selections[index];
        if (item === 'X' || item === 'O') return false;
        
        const newSelections = [...selections];
        
        if (turn === 1) {
            newSelections[index] = 'X';
            setTurn(2);
        } else {
            newSelections[index] = 'O';
            setTurn(1);
        };
        
        setSelections(newSelections);
    };
    
    return (
        <div id='ttt-container'>
            <h2>Tic Tac Toe</h2>
            
            {!winner ?
                <p className='ttt-message'>It is {turn === 1 ? "X's turn" : turn === 2 ? "O's turn" : "Cat's Game!"}</p>
            : winner === 1 ?
                <p className='ttt-message'>X has won!</p>
            : winner === 2 ?
                <p className='ttt-message'>O has won!</p>
            : winner === 3 &&
                <p className='ttt-message'>Cat's game!</p>
            }
            <div id='ttt-gameboard-container'>
                {selections.map((el, i) => 
                    <button 
                        key={i}
                        className='ttt-gameboard-item' 
                        onClick={() => updateSelections(i)}
                    >{el}</button>
                )}
            </div>
            
            <div id='ttt-input-div'>
                <button id='ttt-clear-button'
                    onClick={() => {setSelections(defaultBoard); setTurn(1); setWinner(null)}}
                >Clear Board</button>
            </div>
  
        </div>
    );
};

export default TicTacToe;
